// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.347 8.187a.96.96 0 00-1.344.204l-4.557 6.186-2.898-2.32a.962.962 0 00-1.203 1.503l3.68 2.944a.972.972 0 001.375-.181l5.154-6.99a.962.962 0 00-.206-1.345h-.001z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>";
// Exports
module.exports = code;